import React from 'react';
import { WifiOff } from 'lucide-react';
import { useBackendHealth } from '../../hooks/useBackendHealth';
import './BackendUnreachableBanner.css';

function formatDuration(seconds) {
  if (seconds == null) return 'unknown';
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${h}h ${m}m`;
}

function formatTime(date) {
  if (!date) return 'never';
  return date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function BackendUnreachableBanner() {
  const { status, lastSuccessAt, secondsSinceLastSuccess } = useBackendHealth();

  if (status !== 'unreachable') return null;

  return (
    <div className="backend-unreachable-banner" role="alert" aria-live="assertive">
      <div className="backend-unreachable-banner__content">
        <WifiOff size={18} className="backend-unreachable-banner__icon" />
        <div className="backend-unreachable-banner__text">
          <strong>Backend unreachable.</strong>
          {' '}
          The dashboard is showing stale data. Last successful contact:{' '}
          <span className="backend-unreachable-banner__timestamp">
            {formatTime(lastSuccessAt)}
          </span>
          {secondsSinceLastSuccess != null && (
            <>
              {' '}
              ({formatDuration(secondsSinceLastSuccess)} ago)
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BackendUnreachableBanner;
